var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSecurity = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
    fill: "#CEE0EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3857 10.515C18.3873 10.5162 18.3886 10.5173 18.3897 10.5183V18.8711H6.62988V10.5183C6.63102 10.5173 6.63235 10.5162 6.63391 10.515C6.65397 10.4992 6.6967 10.4792 6.7583 10.4792H18.2613C18.3229 10.4792 18.3657 10.4992 18.3857 10.515ZM6.62407 10.5242C6.62405 10.5242 6.6242 10.524 6.62458 10.5235L6.62407 10.5242ZM18.3951 10.5235C18.3954 10.524 18.3956 10.5242 18.3956 10.5242L18.3951 10.5235Z",
    stroke: "#051029",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21729 9.62311V7.07585C7.21729 4.49604 9.15543 2.40588 11.5476 2.40588C13.9398 2.40588 15.878 4.49604 15.878 7.07585V9.62311",
    stroke: "#051029",
    strokeWidth: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8023 18.2838V9.53722C17.8023 9.31892 17.577 9.14197 17.2989 9.14197H5.7959C5.51786 9.14197 5.29248 9.31892 5.29248 9.53722V18.2838H17.8023Z",
    fill: "#489BD5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3318 13.9392L12.255 14.0399V14.1665V15.1563C12.255 15.6468 11.8977 15.9842 11.5474 15.9842C11.1972 15.9842 10.8399 15.6468 10.8399 15.1563V14.1665V14.0399L10.7631 13.9392C10.5887 13.7103 10.479 13.4462 10.479 13.1516C10.479 12.4395 10.9978 11.9227 11.5474 11.9227C12.0971 11.9227 12.6159 12.4395 12.6159 13.1516C12.6159 13.4462 12.5062 13.7103 12.3318 13.9392Z",
    fill: "#CEE0EC",
    stroke: "#051029",
    strokeWidth: 0.75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.94 9.4945C16.94 9.39766 16.902 9.31154 16.8423 9.24197H17.3212C17.435 9.24197 17.5341 9.27592 17.6023 9.32589C17.6706 9.37591 17.7023 9.43671 17.7023 9.4945V18.1838H16.94V9.4945Z",
    fill: "#004288",
    stroke: "#489BD5",
    strokeWidth: 0.2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSecurity);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/security.b97ca223ddd29131d03a500212a8ba1b.svg";